import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'resolveLabel' })
export class ResolveLabelPipe implements PipeTransform {
  transform(
    options: { label: string; value: number }[],
    value: number,
  ): string | null {
    return options.find((o) => o.value === value)?.label ?? null;
  }
}
